import { AlertTriangle } from 'lucide-react';

type WarningBannerProps = {
  text: string;
  variant?: 'warning' | 'hard-stop';
};

const WarningBanner: React.FC<WarningBannerProps> = ({ text, variant = 'warning' }: WarningBannerProps) => {
  const isHardStop = variant === 'hard-stop';

  return (
    <div
      className={`flex items-start gap-[10px] px-[14px] py-[12px] rounded-[10px] border ${
        isHardStop
          ? 'bg-[#fef2f2] border-[#fecaca]'
          : 'bg-[#fffbeb] border-[#fde68a]'
      }`}
      data-name="warning-banner"
    >
      <AlertTriangle
        className={`w-[18px] h-[18px] shrink-0 mt-[2px] ${
          isHardStop ? 'text-[#dc2626]' : 'text-[#d97706]'
        }`}
      />
      <p className={`font-['Manrope:Regular',sans-serif] font-normal leading-[1.5] text-[14px] ${
        isHardStop ? 'text-[#991b1b]' : 'text-[#92400e]'
      }`}>
        {text}
      </p>
    </div>
  );
}

export default WarningBanner;